<ds-truncatable-part [maxLines]="1" [background]="isCurrent() ? 'primary' : 'default'" [showToggle]="false">
  <div [ngClass]="isCurrent() ? 'text-light' : 'text-body'"
  [innerHTML]="(parentTitle$ && parentTitle$ | async) ? (parentTitle$ | async) : ('home.breadcrumbs' | translate)"></div>
</ds-truncatable-part>
<ds-truncatable-part [maxLines]="1" [background]="isCurrent() ? 'primary' : 'default'" [showToggle]="false">
  <div class="fw-bold"
    [ngClass]="isCurrent() ? 'text-light' : 'text-primary'"
  [innerHTML]="dsoTitle"></div>
</ds-truncatable-part>
@if (description) {
  <ds-truncatable-part [maxLines]="1" [background]="isCurrent() ? 'primary' : 'default'" [showToggle]="false">
    <div class="text-secondary"
      [ngClass]="isCurrent() ? 'text-light' : 'text-secondary'"
    [innerHTML]="description"></div>
  </ds-truncatable-part>
}
